import type { Stroke } from '../types/app.js';

/** Fit the drawing into the Layers preview while preserving its direction and proportions. */
export function drawingPreviewPoints(stroke: Pick<Stroke, 'points'>): string | null {
  if (stroke.points.length < 2) return null;
  let minLongitude = Infinity, maxLongitude = -Infinity, minLatitude = Infinity, maxLatitude = -Infinity;
  for (const { lat, lng } of stroke.points) {
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    minLongitude = Math.min(minLongitude, lng); maxLongitude = Math.max(maxLongitude, lng);
    minLatitude = Math.min(minLatitude, lat); maxLatitude = Math.max(maxLatitude, lat);
  }
  const longitudeSpan = maxLongitude - minLongitude, latitudeSpan = maxLatitude - minLatitude;
  if (!longitudeSpan && !latitudeSpan) return null;
  const scale = Math.min(longitudeSpan ? 28 / longitudeSpan : Infinity, latitudeSpan ? 16 / latitudeSpan : Infinity);
  const offsetX = (32 - longitudeSpan * scale) / 2, offsetY = (20 - latitudeSpan * scale) / 2;
  return stroke.points.map(point => `${(offsetX + (point.lng - minLongitude) * scale).toFixed(1)},${(offsetY + (maxLatitude - point.lat) * scale).toFixed(1)}`).join(' ');
}
